import { render, staticRenderFns } from "./RegisterOtp.vue?vue&type=template&id=191d4e9c&scoped=true"
import script from "./RegisterOtp.vue?vue&type=script&lang=js"
export * from "./RegisterOtp.vue?vue&type=script&lang=js"
import style0 from "./RegisterOtp.vue?vue&type=style&index=0&id=191d4e9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191d4e9c",
  null
  
)

export default component.exports